/** @file This file contains type and class definition for the code highlights within the plagiarism export. */
import { helpers } from '@codegrade/utils';
const getUniqueId = helpers.makeUniqueCounter();
/** Class representing a highlight with a specific color and an id. */
export class Highlight {
    /**
     * @param background The background color.
     * @param foreground The foreground color.
     */
    constructor(background, foreground) {
        this.background = background;
        this.foreground = foreground;
        /** The id of the highlight. */
        this.id = `${getUniqueId()}`;
    }
}
